import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify';
import Loader from '../../Loader/Loader';
import CommonTable from '../../Table/CommonTable';
import './Astrologer.css'
import { API_END_POINT, TOKEN } from '../../../constant';
import { useParams } from 'react-router-dom';

function Astrologer() {
  const [loading, setLoading] = useState(false)
  const [astrologerName, setAstrologerName] = useState('');
  const [astrologerBio, setAstrologerBio] = useState('');
  const [experience, setExperience] = useState('');
  const [minuteWiseRate, setMinuteWiseRate] = useState('');
  const [chatWiseMinuteRate, setChatWiseMinuteRate] = useState()
  const [languages, setLanguages] = useState([]);
  const [specializations, setSpecializations] = useState([1]);
  const [selectedFile, setSelectedFile] = useState('')
  const [imageId, setImageId] = useState(null)
  const [astrologers, setAstrologers] = useState([]);
  const [email, setEmail] = useState()
  const [mobileNo, setMobileNo] = useState();
  const [gender, setGender] = useState('FEMALE')
  // const [astrologerId, setAstrologerId] = useState(null);
  const [isOnline, setIsOnline] = useState({});
  const [showAstrologoerUpdateFrom, setShowAstrologoerUpdateFrom] = useState(false);

  const { id } = useParams();

  const astrologerId = id;

  useEffect(() => {
    console.log("astrologer id is => ", id)
    // setAstrologerId(id);
    console.log("useEffet getAstrologer()--->>")
    getAstrologer();
  }, [id])


  const handleMainImageUpload = async (e) => {
    e.preventDefault();
    setLoading(true)
    if (!selectedFile) {
      toast.error('No image selected! Please select an image.');
      setLoading(false)
      return
    }
    const formData = new FormData();
    formData.append('file', selectedFile);

    try {
      const response = await fetch(`${API_END_POINT}fileAttachment/uploadImages`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${TOKEN}`,
        },
        body: formData,
      });
      if (!response.ok) {
        toast.error('Failed to upload image');
      }
      const data = await response.json();
      console.log("object", data)
      console.log("this image link is ", data.data.fileId)
      toast.success('Image uploaded successfully!');
      setImageId(data.data.fileId)
      console.log("image id ", imageId)
    } catch (error) {
      toast.error('Error uploading image');
    }
    finally {
      setLoading(false)
    }
  };


  const handleAstrologerUpdate = (row) => {
    setAstrologerBio(row.astrologerBio)
    setAstrologerName(row.astrologerName)
    setMinuteWiseRate(row.minuteWiseRate)
    setChatWiseMinuteRate(row.chatMinuteWiseRating)
    setLanguages(row.languages)
    // setSpecializations(row.specializations)
    setExperience(row.experience)
    setEmail(row.email)
    setMobileNo(row.mobileNo)
    setShowAstrologoerUpdateFrom(prevState => !prevState)
  }

  const checkFormValidations = (e) => {
    e.preventDefault();
    if (!astrologerName) {
      toast.error('astrologer name cannot be empty')
      return
    }
    if (!mobileNo || mobileNo.length !== 10) {
      toast.error("Mobile number must be 10 digits.")
      return
    }
    if (!email) {
      toast.error('email cannot be empty')
      return
    }
    updateAstrologer()
  }

  const updateAstrologer = async () => {
    setLoading(true)
    const updateAstrologerUrl = `${API_END_POINT}astrologers/update/${astrologerId}`
    const updateAstrologerData = {
      formData: {
        astrologerName: astrologerName,
        astrologerBio: astrologerBio,
        experience: experience,
        minuteWiseRate: minuteWiseRate,
        chatWiseMinuteRate: chatWiseMinuteRate,
        languages: languages.map(language => language.id),
        specializations: [1],
        fileId: imageId,
        mobileNo: mobileNo,
        email: email
      }
    }
    const updateAstrologerHeaders = {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${TOKEN}`
    }
    try {
      const response = await fetch(updateAstrologerUrl, { method: 'PUT', headers: updateAstrologerHeaders, body: JSON.stringify(updateAstrologerData) })
      if (!response.ok) {
        toast.error("Failed to update astrologer")
        return;
      }
      const responseData = await response.json();
      toast.success("Astrologer updated successfully");
      setAstrologerBio()
      setAstrologerName()
      setMinuteWiseRate()
      setLanguages()
      setShowAstrologoerUpdateFrom(false)
      getAstrologer();
    } catch (error) {
      console.log("error while updating astrologer", error)
    } finally {
      setLoading(false)
    }
  }


  const handleStatusChange = async (id) => {
    setLoading(true)

    const updateStatusUrl = `${API_END_POINT}astrologers/updateCurrentStatus/${id}`
    const updateStatusHeader = {
      Authorization: `Bearer ${TOKEN}`
    }
    try {

      const response = await fetch(updateStatusUrl, { method: 'PUT', headers: updateStatusHeader })

      if (!response.ok) {
        toast.error("failed to update status")
        return
      }
      toast.success("status changed successfully")
      const responseData = response.json();
      getAstrologer()

    } catch (error) {
      console.log("handle status change --->>>", error)

    } finally {
      setLoading(false)
    }
  };

  const getAstrologer = async () => {
    setLoading(true)
    const getAstrologerUrl = `${API_END_POINT}astrologers/get-astrologer?astrologerId=${astrologerId}`
    const getAstrologerHeaders = {
      Authorization: `Bearer ${TOKEN}`
    }
    try {
      const response = await fetch(getAstrologerUrl, { method: 'GET', headers: getAstrologerHeaders })

      if (!response.ok) {
        toast.error("error while trying to get astrologer's details")
      } 
      const responseData = await response.json();
      setAstrologerName(responseData.data.astrologerName)

      setAstrologers([responseData.data])

    } catch (error) {
      console.log("api response error for getAstrologer()--->>>")
    }
    finally {
      setLoading(false)
    }
  }


  const columns = [
    {
      name: 'Astrologer Id',
      cell: (row, index) => row.id,
    },
    {
      name: "Astrologer Name",
      cell: (row) => row?.astrologerName,
    },
    {
      name: "Profile Image",
      cell: (row) => <img
        title='Click to see Image'
        src={`${API_END_POINT}${row?.profile[0]}`}
        width={"auto"}
        height={"70"}
        alt="Blog Image"
      />
    },
    {
      name: 'Actions',
      cell: (row, index) => (
        <div className='flex align-center gap-10' onClick={() => {
          console.log("this is row ", row)
          handleAstrologerUpdate(row)
        }} >
          <button className='edit-btn'>
            <svg width="25" height="25" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path d="m7 17.011 4.413-.015 9.632-9.54c.378-.378.586-.88.586-1.414 0-.534-.208-1.036-.586-1.414l-1.586-1.586c-.756-.756-2.075-.752-2.825-.003L7 12.581v4.43ZM18.045 4.456l1.589 1.583-1.597 1.582-1.586-1.585 1.594-1.58ZM9 13.416l6.03-5.974 1.586 1.586L10.587 15 9 15.004v-1.589Z"></path>
              <path d="M5 21h14c1.103 0 2-.897 2-2v-8.668l-2 2V19H8.158c-.026 0-.053.01-.079.01-.033 0-.066-.009-.1-.01H5V5h6.847l2-2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2Z"></path>
            </svg>
          </button>

        </div>
      ),
    },
    {
      name: "Status",
      cell: (row, index) => {
        isOnline[row?.id] = row?.currentStatus
        // console.log(isChecked[row?.id], 'and', row?.active)
        return (
          <div className="button r" id="button-1">
            <input type="checkbox" className="checkbox" checked={isOnline[row?.id]} onChange={(e) => (handleStatusChange(row?.id))} />
            <div className="knobs"></div>
            <div className="layer"></div>
          </div>
        )
      }
    },
  ]



  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedFile(file);
    } else {
      toast.error("No file selected");
    }
  };

  const isLanguageIdExist = (id) => {
    if (!languages || !languages.length) {
      return false;
    }
    return languages.some((lang) => lang.id === id);
  };

  const handleCheckbox = (e) => {
    const value = parseInt(e.target.value);
    setLanguages((prevLanguages) => {
      // Ensure prevLanguages is an array
      const languagesArray = prevLanguages || [];

      if (e.target.checked) {
        // Add the language if not already present
        if (!languagesArray.some((lang) => lang.id === value)) {
          return [...languagesArray, { id: value }];
        }
        return languagesArray;
      } else {
        // Remove the language if present
        return languagesArray.filter((lang) => lang.id !== value);
      }
    });
  };

  return (
    <main className='main'>
      <h3>Welcome : {astrologerName}</h3>
      {!loading ? (
        <div>
          <div style={{ marginTop: "10px" }} className='flex align-center justify-end'>
          </div>
          {showAstrologoerUpdateFrom && (
            <form className='form'>
              <div className='input-field flex flex-col'>
                <label htmlFor="blogName">Astrologer Name</label>
                <input
                  id='blogName'
                  type="text"
                  name="blogName"
                  value={astrologerName}
                  onChange={(e) => (setAstrologerName(e.target.value))}
                  placeholder="Enter Astrologer Name"
                />
              </div>
              <div className='input-field flex flex-col'>
                <label htmlFor="blogName">Astrologer Bio</label>
                <input
                  id='blogName'
                  type="text"
                  name="blogName"
                  value={astrologerBio}
                  onChange={(e) => (setAstrologerBio(e.target.value))}
                  placeholder="Enter Astrologer Bio"
                />
              </div>
              {/* <div className='input-field flex flex-col'>
                <label htmlFor="gender">Gender</label>
                <div className='gender-select'>
                  <label className="custom-radio">
                    <input
                      type="radio"
                      name="gender"
                      value="MALE"
                      checked={gender === 'MALE'}
                      onChange={(e) => setGender(e.target.value)}  // Updates the gender state to "Male"
                      required
                    />
                    Male
                  </label>
                  <label className="custom-radio">
                    <input
                      type="radio"
                      name="gender"
                      value="FEMALE"
                      checked={gender === 'FEMALE'}
                      onChange={(e) => setGender(e.target.value)}
                      required
                    />
                    Female
                  </label>
                </div>
              </div> */}
              <div className='input-field flex flex-col'>
                <label htmlFor="blogName">Astrologer Email</label>
                <input
                  id='blogName'
                  type="text"
                  name="blogName"
                  value={email}
                  onChange={(e) => (setEmail(e.target.value))}
                  placeholder="Enter Astrologer Name"
                />
              </div>
              <div className='input-field flex flex-col'>
                <label htmlFor="blogName">Mobile No</label>
                <input
                  id='blogName'
                  type="number"
                  name="blogName"
                  value={mobileNo}
                  onChange={(e) => (setMobileNo(e.target.value))}
                  placeholder="Enter Mobile No "
                />
              </div>
              <div className='input-field flex flex-col'>
                <label htmlFor="blogName">Astrologer Languages</label></div>
              <div className='languageSelect' >
                <label className="custom-checkbox">
                  <input type="checkbox" name="Fast and Festival" value={'1'} onClick={handleCheckbox} className="checkbox-input" defaultChecked={isLanguageIdExist(1)} />
                  English
                </label>
                <label className="custom-checkbox">
                  <input type="checkbox" name="Fast and Festival" value={'2'} onClick={handleCheckbox} className="checkbox-input" defaultChecked={isLanguageIdExist(2)} />
                  Hindi
                </label>
                <label className="custom-checkbox">
                  <input type="checkbox" name="Fast and Festival" value={'3'} onClick={handleCheckbox} className="checkbox-input" defaultChecked={isLanguageIdExist(3)} />
                  Marathi
                </label>
                <label className="custom-checkbox">
                  <input type="checkbox" name="Fast and Festival" value={'4'} onClick={handleCheckbox} className="checkbox-input" defaultChecked={isLanguageIdExist(4)} />
                  Gujarati
                </label>
              </div>
              <div className='minutesinputfield'>
                <label htmlFor="minuteWiseRate">Astrologer Charges per Minute (in Rs)</label>
                <input
                  type="number"
                  id="minuteWiseRate"
                  value={minuteWiseRate}
                  onChange={(e) => setMinuteWiseRate(e.target.value)}
                />
              </div>
              <div className='minutesinputfield'>
                <label htmlFor="minuteWiseRate">Astrologer Chat Charges per Minute (in Rs)</label>
                <input
                  type="number"
                  id="minuteWiseRate"
                  value={chatWiseMinuteRate}
                  onChange={(e) => setChatWiseMinuteRate(e.target.value)}
                />
              </div>
              <div className='minutesinputfield'>
                <label htmlFor="experience">Experience (in Years)</label>
                <input
                  type="number"
                  id="experience"
                  value={experience}
                  onChange={(e) => setExperience(e.target.value)}
                />
              </div>
              <div className='input-field flex flex-col'>
                <label htmlFor="blogName">Astrologer Main Image</label>
                <input type="file" name="" onChange={handleImageUpload} id="fileupload" />
                <button style={{ width: 'fit-content' }} className='common-btn flex align-center' onClick={handleMainImageUpload}>
                  Add Main Image
                </button>
              </div>
              <div className='buttons flex flex-col'>
                <button type="submit" onClick={checkFormValidations} className='btn'>Update</button>
              </div>
            </form>
          )

          }
          <div style={{ marginTop: "10px" }} onClick={(e) => { console.log("object", e.target) }} >
            <CommonTable columns={columns} data={astrologers} totalRows={1} />
          </div>
        </div>
      ) : (
        <div>
          <Loader />
        </div>
      )}
    </main>
  )
}

export default Astrologer
